import { seesAllStores } from '../data/scope';
import type { AppUser } from '../data/types';

/**
 * "Your access: 6 districts — …" for an Executive limited to named
 * districts/stores (exec reflect 2026-10-25: "Why do I see only these
 * districts?"). null for everyone else — an unlimited executive, and DMs,
 * whose districts already show under the welcome line.
 */
export function limitedAccessLine(user: Pick<AppUser, 'role' | 'districts' | 'storeNumbers'>): string | null {
  if (user.role !== 'Executive' || seesAllStores(user)) return null;
  const parts: string[] = [];
  const d = user.districts.map((x) => x.trim()).filter(Boolean);
  const s = user.storeNumbers.map((x) => x.trim()).filter(Boolean);
  if (d.length > 0) parts.push(`${d.length} ${d.length === 1 ? 'district' : 'districts'} — ${d.join(', ')}`);
  if (s.length > 0) parts.push(`${s.length} ${s.length === 1 ? 'store' : 'stores'} — ${s.join(', ')}`);
  return `Your access: ${parts.join('; ')} (set by an admin)`;
}
